<template>
  <path
    id="sortujRevert"
    d="M4.57227965,16.1374298 L4.57227965,3.52588235 L6.85691636,3.52588235 L6.85691636,16.0294835 L9.69933012,13.1870697 L11.3193872,14.8071268 L5.66519983,20.4613142 L-0.005,14.7911143 L1.6104821,13.1756322 L4.57227965,16.1374298 Z M21.2302431,20.3051765 L20.6461874,18.8468129 L17.4922865,18.8468129 L16.9135403,20.3051765 L15.5436641,20.3051765 L18.4267756,13.5258824 L19.7063887,13.5258824 L22.6054289,20.3051765 L21.2302431,20.3051765 Z M17.8975858,18.0454118 L20.2515074,18.0454118 L19.0798482,14.6557647 L19.069245,14.6557647 L17.8975858,18.0454118 Z M17.3136148,9.43975117 L21.4284681,9.43975117 L21.4284681,10.4741176 L15.5436641,10.4741176 L15.5436641,9.57021176 L19.5796025,4.74782729 L19.5796025,4.72919005 L15.7240414,4.72919005 L15.7240414,3.69482353 L21.4115577,3.69482353 L21.4115577,4.58475148 L17.3136148,9.42577325 L17.3136148,9.43975117 Z"
    :fill="iconColor"
  />
</template>

<script>
export default {
    name: 'SortIconRevert',
    props: {
        iconColor: {
            type: String,
            default: 'currentColor'
        }
    }
};
</script>

<style scoped></style>
